import { useState } from "react"
import {
  LabelSmall,
  ParagraphSmall,
  Settings01,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { useField } from "formik"

import SlideUpMenu from "#/shared/components/SlideUpMenu"
import { StakingLockDurationType } from "#/shared/types"
import { stakingUtils } from "#/shared/utils"

import StakingItemContainer from "../StakingItemContainer"

import LockDurationMenu from "./LockDurationMenu"

type LockDurationProps = {
  fieldName: string
  stakeAmount: bigint
}

export default function LockDuration({
  fieldName,
  stakeAmount,
}: LockDurationProps) {
  const [css, theme] = useStyletron()

  const [, { value: lockDuration }] =
    useField<StakingLockDurationType>(fieldName)

  const [showLockDurationMenu, setShowLockDurationMenu] = useState(false)

  return (
    <>
      <StakingItemContainer>
        <ParagraphSmall color={theme.colors.contentTertiary}>
          Lock duration
        </ParagraphSmall>

        <LabelSmall
          className={css({
            display: "flex",
            alignItems: "center",
            gap: theme.sizing.scale300,
            cursor: "pointer",
            textTransform: "lowercase",
          })}
          onClick={() => setShowLockDurationMenu(true)}
        >
          {stakingUtils.getLockDurationLabel(lockDuration)}
          <Settings01 size={16} color={theme.colors.contentPrimary} />
        </LabelSmall>
      </StakingItemContainer>

      <SlideUpMenu
        isOpen={showLockDurationMenu}
        header="Lock settings"
        height="620px"
        onClose={(event) => {
          event.preventDefault()

          setShowLockDurationMenu(false)
        }}
      >
        <LockDurationMenu
          isOpen={showLockDurationMenu}
          fieldName={fieldName}
          onClose={() => setShowLockDurationMenu(false)}
          stakeAmount={stakeAmount}
        />
      </SlideUpMenu>
    </>
  )
}
